module.exports = __webpack_public_path__ + "images/emoji/capricorn.1e7c1a089f85d329b981.png";